import React from "react";
import { useLocalization } from "@fluent/react";
import { Button, Dialog, Row } from "@narmi/design_system";

import type { DataAccessConsent } from "./types";

interface RevokeConfirmationDialogProps {
  connection: DataAccessConsent | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RevokeConfirmationDialog = ({
  connection,
  isOpen,
  onClose,
  onConfirm,
}: RevokeConfirmationDialogProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onClose}
      title={l10n.getString("revoke-access-dialog-title")}
      footer={
        <Row justifyContent="end" alignItems="center">
          <Row.Item shrink>
            <Button
              kind="plain"
              label={l10n.getString("button-cancel")}
              onClick={onClose}
              testId="cancel-revoke-access"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="primary"
              label={l10n.getString("button-revoke-access")}
              onClick={onConfirm}
              testId="confirm-revoke-access"
            />
          </Row.Item>
        </Row>
      }
    >
      {connection && (
        <>
          <p>
            {l10n.getString("revoke-access-dialog-body", {
              applicationName: connection.display_name,
            })}
          </p>
          <p>{l10n.getString("revoke-access-dialog-note")}</p>
        </>
      )}
    </Dialog>
  );
};

export default RevokeConfirmationDialog;
